module.exports = __webpack_public_path__ + "img/charging-hub-in-progress-private.b7775027.svg";